// extracted by mini-css-extract-plugin
module.exports = {"speech-card-box":"fg","speechCardBox":"fg","speech-img-box":"fh","speechImgBox":"fh","card-content":"fi","cardContent":"fi","card-src":"fj","cardSrc":"fj"};